import { statusColors } from '../model/constants';
import { ConditionStatus } from '../model/types';
import styles from './styles.module.scss';
import { useVhcBlock } from './useVhcBlock';
import { useVhcSaveItem } from './useVhcSaveItem';
import cn from 'classnames';
import { InlineSvg } from 'components/svg';
import { VhcItem } from 'features/vhc/model';

interface IProps {
  data: VhcItem;
  isCompleted: boolean;
}

export const VhcBlock = ({ data, isCompleted = false }: IProps) => {
  const { conditionId, isNew } = data || {};

  const { statusIcon, blockClass } = useVhcBlock({ conditionId: data?.conditionId || ConditionStatus.NOT_TESTED });

  const { isSaving, handleOpenVhcRecordModal, handlePlusClick } = useVhcSaveItem({ item: data });

  return (
    <div
      aria-disabled={isSaving}
      className={cn(styles.vhcBlock, blockClass)}
      onClick={isSaving || isCompleted ? undefined : handleOpenVhcRecordModal}
    >
      <div className={styles.blockTitle}>
        <div
          aria-disabled={isNew}
          className={cn(styles.plusIcon, isNew && styles.plusIconDisabled)}
          onClick={isCompleted ? undefined : handlePlusClick}
        >
          <InlineSvg
            path="/media/icons/duotune/arrows/arr075.svg"
            className={cn('svg-icon-2 text-white', {
              'text-primary': conditionId === ConditionStatus.NOT_OK
            })}
          />
        </div>
        <div className={cn(' d-flex flex-row align-items-center', conditionId && statusColors[conditionId])}>
          <div>{isSaving ? 'Creating...' : data?.description}</div>
          <div>
            <InlineSvg
              path="/media/icons/custom/right-arrow.svg"
              className={cn('svg-icon-2 ms-2', conditionId && statusColors[conditionId])}
            />
          </div>
        </div>
      </div>
      <div className={styles.blockStatus}>{statusIcon}</div>
    </div>
  );
};
